<template>
  <div>
    <div class="login" v-if="!loading && !loadingExternalLogin">
      <div class="left">
        <img class="logo" src="~@/assets/logo.svg" />
        <h3>Transforming Procurement</h3>
        <img class="people" src="~@/assets/icons/login_illustration.svg" />
      </div>

      <div class="right">
        <h3 v-show="view === 'login'">Login</h3>
        <h3 v-show="view === 'confirm_details'">Update your password</h3>
        <h3 v-show="view === 'more_info'">Update your details</h3>

        <form @submit.prevent="login()" v-show="view === 'login'">
          <material-input
            v-model="username"
            type="email"
            label="Email"
            :required="true"
            name="Email"
          />
          <material-input
            v-model="password"
            type="password"
            label="Password"
            :required="true"
            name="Password"
          />
          <b-button type="submit">
            <b-spinner v-if="loadingLogin" small variant="light"></b-spinner>
            {{ loadingLogin ? '' : 'Log In' }}
          </b-button>
          <router-link class="link" to="/forgotpassword"
            >Forgot password?</router-link
          >
<!--          <a class="link" @click="$store.dispatch('loginWithAzureAD')"-->
<!--            >Log In With Microsoft</a-->
<!--          >-->
        </form>

        <form
          @submit.prevent="change_password()"
          v-show="view === 'new_password'"
          autocomplete="nope"
        >
          <material-input
            v-model="new_password"
            type="password"
            label="Create New Password"
            :required="true"
            autocomplete="new-password"
            name="NewPassword"
            :preventAutofill="true"
          />
        </form>

        <form
          @submit.prevent="complete_challenge()"
          v-show="view === 'confirm_details'"
          autocomplete="nope"
        >
          <material-input
            v-model="new_password"
            type="password"
            label="Create New Password"
            :required="true"
            autocomplete="new-password"
            name="NewPassword"
          />

          <password-checks
            :password="new_password"
            :onChange="setNewPasswordValidity"
          />

          <b-button type="submit" :disabled="!new_password_valid">
            <b-spinner
              v-if="loadingCompleteChallenge"
              small
              variant="light"
            ></b-spinner>
            {{ loadingCompleteChallenge ? '' : 'Continue' }}
          </b-button>
        </form>

        <form
          @submit.prevent="update_profile()"
          v-show="view === 'more_info'"
          autocomplete="nope"
        >
          <material-input
            v-model="firstName"
            type="text"
            label="First Name"
            :required="true"
            autocomplete="f-name"
            name="FirstName"
            :preventAutofill="true"
          />
          <material-input
            v-model="lastName"
            type="text"
            label="Last Name"
            :required="true"
            autocomplete="l-name"
            name="LastName"
            :preventAutofill="true"
          />

          <dropdown
            :options="jobTitle_options"
            :value="jobTitle"
            :onChange="val => (jobTitle = val)"
            placeholder="Role"
          />

          <dropdown
            :options="category_options"
            :value="categoryId"
            :onChange="val => (categoryId = val)"
            placeholder="Team"
          />

          <b-button
            type="submit"
            :disabled="!firstName || !lastName || !jobTitle || !categoryId"
          >
            <b-spinner
              v-if="loadingUpdateProfile"
              small
              variant="light"
            ></b-spinner>
            {{ loadingUpdateProfile ? '' : 'Continue' }}
          </b-button>
        </form>

        <div class="feedback" v-show="feedback">{{ feedback }}</div>

        <div class="spacer"></div>
      </div>
    </div>

    <div class="loading_visible" v-else>
      <img class="logo" src="~@/assets/logo_black.svg" />
      <img
        class="loading_illustration"
        src="~@/assets/icons/loading_illustration.svg"
      />
      <h4>Loading</h4>
      <b-progress :value="100" animated />
    </div>
  </div>
</template>

<script>
import MaterialInput from '../components/MaterialInput.vue';
import Dropdown from '../components/Dropdown';
import PasswordChecks from '../components/PasswordChecks';

export default {
  name: 'Auth',
  data() {
    return {
      view: 'login',
      username: '',
      password: '',
      new_password: '',
      new_password_valid: false,
      firstName: '',
      lastName: '',
      jobTitle: '',
      categoryId: null,
      times: 0,
      token_result: null,
      loading: false,
      loadingLogin: false,
      loadingExternalLogin: false,
      loadingCompleteChallenge: false,
      loadingUpdateProfile: false,
      feedback: '',
      firstLogin: false,
      jobTitle_options: [
        { value: 'Legal', text: 'Legal' },
        { value: 'Finance', text: 'Finance' },
        { value: 'Business', text: 'Business' },
        { value: 'Procurement', text: 'Procurement' },
        { value: 'Other', text: 'Other' },
      ],
    };
  },
  components: {
    'material-input': MaterialInput,
    dropdown: Dropdown,
    'password-checks': PasswordChecks,
  },
  mounted() {
    if (this.$route.query.error) {
      const { error, error_description } = this.$route.query;
      console.log({ error, error_description });
      switch (error_description) {
        case 'PreSignUp failed with error A user with that email exists. ':
          this.feedback = 'A user with your email already exists.';
          break;
        case 'PreSignUp failed with error No organization registered with that Idp key. ':
          this.feedback =
            'Your Identity Provider has not been registered with a ProjectView organization';
          break;
        default:
          this.feedback = 'Failed to login user using external provider';
      }
    } else if (this.$route.query.code) {
      this.loginCodeGrant(this.$route.query.code);
    }
  },
  watch: {
    app_user(newValue) {
      if (newValue) {
        this.firstName = newValue.firstName;
        this.lastName = newValue.lastName;
        this.jobTitle = newValue.jobTitle;
        this.categoryId = newValue.categoryId;
      }
    },
  },
  computed: {
    app_user() {
      return this.$store.getters.app_user;
    },
    requires_more_info() {
      if (!this.app_user) return false;

      const { firstName, lastName, jobTitle, categoryId } = this.app_user;

      if (!firstName || !lastName || !jobTitle || !categoryId) {
        return true;
      }

      return false;
    },
    categories() {
      return this.$store.getters.categories;
    },
    category_options() {
      return Object.keys(this.categories).map(key => {
        const cat = this.categories[key];
        return { value: cat.id, text: cat.name };
      });
    },
  },
  methods: {
    setNewPasswordValidity(valid) {
      this.new_password_valid = valid;
    },
    // TODO: Add persistent login
    // auth.vue mounted() if !codeGrant check getter for refresh token
    // set loading animation
    // do refresh token auth flow
    // get app data
    // route to projects
    async login() {
      try {
        this.feedback = '';
        this.loadingLogin = true;

        const result = await this.$store.dispatch('login', {
          Username: this.username.toLowerCase(),
          Password: this.password,
        });

        if (result.type === 'success') {
          this.token_result = result.result;
          this.save_token();
        } else if (result.type === 'completeProfileChallenge') {
          this.view = 'confirm_details';
        } else if (result.type === 'newPasswordRequired') {
          this.token_result = result.result;
          this.view = 'new_password';
        } else {
          console.error('Auth result undefined');
        }
      } catch (err) {
        console.error(err.message || JSON.stringify(err));
        this.feedback = err.message;
        switch (err.message) {
          case 'User does not exist.':
            this.feedback = 'Invalid username';
            break;
          case 'Incorrect username or password.':
            this.feedback = 'Authentication failed';
            break;
          default:
            this.feedback = err.message;
        }
      } finally {
        this.loadingLogin = false;
      }
    },
    async loginCodeGrant(code) {
      try {
        this.feedback = '';
        this.loadingExternalLogin = true;

        const result = await this.$store.dispatch('getTokensFromCode', code);
        this.token_result = result;
        this.save_token();
      } catch (err) {
        this.feedback = 'There was an error logging you in';
        console.error(err.message || JSON.stringify(err));
      } finally {
        this.loadingExternalLogin = false;
      }
    },
    async change_password() {
      try {
        const params = {
          old_password: this.password,
          new_password: this.new_password,
        };

        const result = await this.$store.dispatch('changePassword', params);

        if (result.type === 'success') {
          this.save_token();
        } else {
          console.error('Password result undefined');
          this.feedback = 'Error';
        }
      } catch (err) {
        console.error(err.message || JSON.stringify(err));
        this.feedback = err.message;
        this.login();
      }
    },
    async complete_challenge() {
      try {
        this.firstLogin = true;
        this.loadingCompleteChallenge = true;

        const params = {
          new_password: this.new_password,
        };

        const result = await this.$store.dispatch(
          'completeProfileChallenge',
          params
        );

        if (result.type === 'success') {
          this.token_result = result.result;
          this.save_token();
        } else {
          console.error('Challenge result undefined');
          this.feedback = 'Error';
        }
      } catch (err) {
        console.error(err.message || JSON.stringify(err));
        this.feedback = err.message;
        this.login();
      } finally {
        this.loadingCompleteChallenge = false;
      }
    },
    async save_token() {
      try {
        this.loading = true;
        this.$store.dispatch('setTokens', this.token_result);
        this.$store.dispatch('setLoading', false);

        await this.$store.dispatch('getAppUser');
        this.loading = false;

        if (this.firstLogin || this.requires_more_info) {
          this.view = 'more_info';
        } else {
          this.proceed();
        }
      } catch (err) {
        this.loading = false;
        console.error(err.message || JSON.stringify(err));
      }
    },
    async update_profile() {
      try {
        this.loadingUpdateProfile = true;
        await this.$store.dispatch('updateAppUser', {
          id: this.app_user.id,
          firstName: this.firstName,
          lastName: this.lastName,
          jobTitle: this.jobTitle,
          categoryId: this.categoryId,
        });
        await this.$store.dispatch('getAppUser');

        this.proceed();
      } catch (err) {
        this.loading = false;
        console.error(err.message || JSON.stringify(err));
      } finally {
        this.loadingUpdateProfile = false;
      }
    },
    async proceed() {
      this.loading = true;

      const dataPromises = [];
      dataPromises.push(this.$store.dispatch('getUsers'));
      dataPromises.push(this.$store.dispatch('getSuppliers'));
      dataPromises.push(this.$store.dispatch('getCurrencies'));
      if (this.app_user.jobTitle === 'Finance') dataPromises.push(this.$store.dispatch('getApprovals'));
      await Promise.all(dataPromises);

      if (this.app_user.role === 'Stakeholder') {
        await this.$store.dispatch('getSelfServiceConfig');
        await this.$router.replace('/self-service');
      }
      else {
        await this.$router.replace(this.$route.query.redirectTo || '/projects')
      };
    },
  },
  created() {
    this.$ga.page('/login');
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.login {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 80px);

  .left {
    width: 64%;
    height: 100%;
    background: $sidebar-color;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 767px) {
      display: none;
    }

    .logo {
      height: 40px;
      margin: 40px;
      align-self: flex-start;
    }

    h3 {
      font-weight: 500;
      font-size: 36px;
      color: white;
      max-width: 60%;
      margin: 30px auto;
    }

    .people {
      max-height: 50%;
      max-width: calc(100% - 80px);
    }
  }

  .right {
    width: 36%;
    min-width: 320px;
    @media screen and (max-width: 767px) {
      width: 100%;
    }

    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 50px 60px;

    h3 {
      margin-bottom: 0;
      font-weight: 500;
      font-size: 32px;
      color: $sidebar-color;
      align-self: flex-start;
    }

    .spacer {
      height: 20px;
      width: 100%;
    }
  }
}

form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.link {
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  color: #acb6c1 !important;
  text-align: center;
}

.auth {
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 200px;
    margin-bottom: 30px;
  }

  .panel {
    width: 400px;
    min-height: 200px;
    border-radius: 4px;
    background: white;
    padding: 40px;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

.loading_visible {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .logo {
    position: absolute;
    top: 40px;
    left: 40px;
    height: 40px;
  }

  h4 {
    margin: 60px 0;
    max-width: 400px;
    text-align: center;
    font-weight: 500;
    font-size: 28px;
  }

  .progress {
    width: 300px;
    height: 15px;

    ::v-deep .progress-bar {
      background-color: $blue;
    }
  }
}

.feedback {
  color: $red;
  text-align: center;
  width: 100%;
  position: absolute;
  top: calc(50% + 160px);
  font-size: 14px;
}

.material-select {
  ::v-deep .btn {
    padding-top: 0;
    padding-bottom: 0;
    text-transform: none;
    height: 40px;
    margin-bottom: 25px;
    font-size: 14px;
  }
}

.material-input {
  ::v-deep input {
    font-size: 14px;
  }
}
</style>
